import { mutator } from 'satcheljs';
import { onSmimeSignChanged } from '../actions/internalActions';
import store from '../store/store';

/**
 * Mutator that sets the property smimeSign
 */
export default mutator(onSmimeSignChanged, actionMessage => {
    store().isSmimeSign = actionMessage.selectedOption;
});
